import axios from "axios";

/**
 * @return string
 */
const getCsrfToken = () => {
  const metaElem = document.querySelector("meta[name='csrf-token']");
  if (!metaElem) {
    throw Error("meta[name=csrf-token] is not founded.");
  }
  const csrfToken = metaElem.getAttribute("content");
  if (!csrfToken) {
    throw Error("csrf token is not set");
  }
  return csrfToken;
};

/**
 * @var AxiosRequestConfig
 */
const defaultOptions = {
  baseURL: process.env.APP_URL || window.location.origin,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": getCsrfToken(),
  },
};

/** @var AxiosInstance */
const instance = axios.create(defaultOptions);

/**
 * @param any error
 * @return Promise<AxiosResponse|any>
 */
const errorHandler = async (error) => {
  if (!axios.isAxiosError(error)) {
    return error;
  }
  if (!error.response) {
    return error;
  }
  switch (error.response.status) {
    case 422:
      console.info("Validation Error", error.message);
      return parseLaravelErrors(error.response);
    default:
      return error;
  }
};

instance.interceptors.response.use((response) => response, errorHandler);

export default instance;
